import React from 'react'
import uniqid from 'uniqid'

import './styles.scss'
import { Modal } from 'reactstrap'
import { getStaticImage } from 'utils/statics'
import { Button } from 'components/Form'
import { lang } from 'utils/helpers'

const ConfirmModal = props => {
  const { isOpen, toggle, mainText, secondaryText, alternativeText, onClick, isLoading, className } = props

  if (!isOpen) return null

  return (
    <Modal centered id={uniqid()} isOpen={isOpen} toggle={toggle} contentClassName={`confirm-modal ${className || ''}`}>
      <div className='confirm-modal__header'>
        <button className='confirm-modal__close-btn' onClick={toggle}>
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-close-slim-grey.svg')} alt='Close' />
          </figure>
        </button>
      </div>
      <div className='confirm-modal__body'>
        <figure className='confirm-modal__warning-icon'>
          <img src={getStaticImage('/icons/orange-brand/icon-warning-yellow.svg')} alt='Warning' />
        </figure>
        {mainText ? <p className='confirm-modal__main-text'>{mainText}</p> : null}
        {secondaryText ? <p className='confirm-modal__secondary-text'>{secondaryText}</p> : null}
        {alternativeText ? <p className='confirm-modal__alternative-text'>{alternativeText}</p> : null}
      </div>
      <div className='confirm-modal__footer'>
        <Button primary value={lang('dashboard_apply')} onClick={onClick} isSubmitting={isLoading} />
        <Button tertiary value={lang('dashboard_cancel')} onClick={toggle} />
      </div>
    </Modal>
  )
}

export default ConfirmModal
